/**
 * @returns {Object} Products domain methods (bound to `this` of the composed apiService)
 */
export function createProductsMethods() {
  return {
    /** @returns {Promise<import('@prism-ehr/shared').Product[]>} */
    getProducts(params = {}) {
      const query = new URLSearchParams();
      if (params.category) query.set('category', params.category);
      if (params.is_active !== undefined) query.set('is_active', params.is_active);
      const qs = query.toString();
      return this.request(`/products${qs ? `?${qs}` : ''}`, { method: 'GET' });
    },

    /** @returns {Promise<import('@prism-ehr/shared').Product>} */
    createProduct(data) {
      return this.request('/products', { method: 'POST', body: JSON.stringify(data) });
    },

    /** @returns {Promise<import('@prism-ehr/shared').Product>} */
    updateProduct(id, updates) {
      return this.request(`/products/${id}`, { method: 'PATCH', body: JSON.stringify(updates) });
    },

    deleteProduct(id) {
      return this.request(`/products/${id}`, { method: 'DELETE' });
    },

    /** @returns {Promise<import('@prism-ehr/shared').ProductLot[]>} */
    getProductLots(productId) {
      return this.request(`/product-lots?product_id=${productId}`, { method: 'GET' });
    },

    /** @returns {Promise<import('@prism-ehr/shared').ProductLot>} */
    createProductLot(data) {
      return this.request('/product-lots', { method: 'POST', body: JSON.stringify(data) });
    },

    /** @returns {Promise<import('@prism-ehr/shared').ProductLot>} */
    updateProductLot(id, updates) {
      return this.request(`/product-lots/${id}`, { method: 'PATCH', body: JSON.stringify(updates) });
    },

    /** @returns {Promise<import('@prism-ehr/shared').Product[]>} */
    reorderProducts(productIds) {
      return this.request('/products-reorder', { method: 'POST', body: JSON.stringify({ product_ids: productIds }) });
    },

    /** @returns {Promise<import('@prism-ehr/shared').ServiceProduct[]>} */
    getServiceProducts(appointmentTypeId) {
      return this.request(`/service-products?appointment_type_id=${appointmentTypeId}`, { method: 'GET' });
    },

    /** @returns {Promise<import('@prism-ehr/shared').ServiceProduct>} */
    createServiceProduct(data) {
      return this.request('/service-products', { method: 'POST', body: JSON.stringify(data) });
    },

    deleteServiceProduct(id) {
      return this.request(`/service-products/${id}`, { method: 'DELETE' });
    },

    /** @returns {Promise<import('@prism-ehr/shared').ProductUsageLog>} */
    logProductUsage(data) {
      return this.request('/product-usage', { method: 'POST', body: JSON.stringify(data) });
    },

    /** @returns {Promise<import('@prism-ehr/shared').ProductUsageLog[]>} */
    getProductUsage(params = {}) {
      const query = new URLSearchParams();
      if (params.appointment_id) query.set('appointment_id', params.appointment_id);
      if (params.product_id) query.set('product_id', params.product_id);
      const qs = query.toString();
      return this.request(`/product-usage${qs ? `?${qs}` : ''}`, { method: 'GET' });
    },
  };
}
